import React from "react";
import * as PropTypes from "prop-types";
import { measurePropType } from "../propTypes";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import { withTranslation } from "react-i18next";

const MeasureSelector = ({ t, ...rest }) => (
    <div className={rest.className}>
        <FormControl>
            <InputLabel
                variant="standard"
                htmlFor="input"
                shrink={true}
            >
                {t(rest.label)}
            </InputLabel>

            <NativeSelect
                input={<Input id="input" />}
                value={rest.value}
                onChange={(e) => rest.onChange(e.target.value)}
            >
                <option value="percentage">{t("Percentage")}</option>
                <option value="count">{t("Count (in '000s)")}</option>
            </NativeSelect>
        </FormControl>
    </div>
);

MeasureSelector.propTypes = {
    label: PropTypes.string,
    value: measurePropType.isRequired,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

MeasureSelector.defaultProps = {
    label: "Measure",
};

export default withTranslation()(MeasureSelector);
